"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.sendEditExtLink = exports.sendEditToolToggle = exports.sendEditToolRemove = exports.sendEditToolComplete = exports.sendEditToolSelect = exports.sendUploadInitEvent = exports.sendUploadFinishEvent = exports.sendUploadStartEvent = exports.sendEvent = void 0;
var helpers_1 = require("../helpers");
var localStorage_1 = require("../localStorage");
function sendStat(event, doc_id, extra) {
    var docId = doc_id ? doc_id : Number(helpers_1.getDocumentId());
    return fetch(helpers_1.baseUrl + "/statv2/", {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(__assign({ event: event, doc_id: docId > 0 ? docId : null, user_uuid: localStorage_1.getUserUUID(), user_session_uuid: localStorage_1.getSessionUUID(docId) }, (extra ? { extra: extra } : {})))
    })
        .then(function (res) {
        return res.json();
    })
        .then(function (data) {
        return data;
    });
}
function sendEvent(message, doc_id, extra) {
    return sendStat(message, doc_id, extra);
    // return fetch(`${baseUrl}/event/${message}`)
}
exports.sendEvent = sendEvent;
function sendUploadStartEvent(service) {
    return fetch(helpers_1.baseUrl + "/event/" + service + "-upload-start")
        .then(function () { return sendEvent(service + "-upload-start"); });
}
exports.sendUploadStartEvent = sendUploadStartEvent;
function sendUploadFinishEvent(service, doc_id) {
    return fetch(helpers_1.baseUrl + "/event/" + service + "-upload-end")
        .then(function () { return sendEvent(service + "-upload-end", doc_id); });
}
exports.sendUploadFinishEvent = sendUploadFinishEvent;
function sendUploadInitEvent() {
    return sendEvent('init');
}
exports.sendUploadInitEvent = sendUploadInitEvent;
function sendEditToolSelect(tool) {
    return sendEvent(tool + "-select");
}
exports.sendEditToolSelect = sendEditToolSelect;
function sendEditToolComplete(tool) {
    return sendEvent(tool + "-complete");
}
exports.sendEditToolComplete = sendEditToolComplete;
function sendEditToolRemove(tool) {
    return sendEvent(tool + "-remove");
}
exports.sendEditToolRemove = sendEditToolRemove;
function sendEditToolToggle(tool, toggle) {
    return sendEvent(tool + "-" + (toggle ? 'on' : 'off'));
}
exports.sendEditToolToggle = sendEditToolToggle;
function sendEditExtLink(msAction) {
    return sendEvent(msAction + "-extlink");
}
exports.sendEditExtLink = sendEditExtLink;
